// Copyright (c) Bentley Systems
import { useState } from "react";
import { useDeleteFile as UseDeleteFile } from "./useDeleteFile";
import {
  ArchiveActionButton,
  ButtonState,
  ButtonType,
} from "../ArchiveActionButton";
import { useAppDispatch } from "../../../app/hooks";
import { setConfirmation } from "../../../app/confirmation-slice";

export type DeleteFileProps = {
  readonly apiDefinition: () => Promise<Response>;
  onError: (responseStatusCode: number, activityId: string | undefined) => void;
  setToasterDeletedSuccess: (infoMsg: string, docVersionId: number) => void;
  getDocVersionId: () => number;
};

export const DeleteFileActionButton = (props: DeleteFileProps) => {
  const [buttonState, setButtonState] = useState<ButtonState>(
    ButtonState.Primary,
  );

  const preDeleting = () => setButtonState(ButtonState.Loading);

  const getDocVersionId = () => {
    return props.getDocVersionId();
  };
  const postDeleting = () => {
    setButtonState(ButtonState.Primary);
    props.setToasterDeletedSuccess("Document deleted", getDocVersionId());
  };

  const onErrorDeleteFile = (
    responseStatusCode: number,
    activityId: string | undefined,
  ) => {
    setButtonState(ButtonState.Primary);
    props.onError(responseStatusCode, activityId);
  };
  const dispatch = useAppDispatch();

  const { download } = UseDeleteFile({
    apiDefinition: props.apiDefinition,
    preDeleting,
    postDeleting,
    onError: onErrorDeleteFile,
  });

  const handleClick = () => {
    dispatch(
      setConfirmation({
        isConfirmationOpen: true,
        onOkAction: download,
        caption: "Delete document?",
        text: `Do you really want to delete document?`,
      }),
    );
  };

  return (
    <div>
      <ArchiveActionButton
        buttonState={buttonState}
        onClick={handleClick}
        buttonType={ButtonType.Delete}
      />
    </div>
  );
};
